import getEnvValue from '@joybird/joystagram-components/dist/esm/getEnvValue';

const isKustomerChatEnabled = () => {
  const KUSTOMER_ENABLED = getEnvValue('REACT_APP_KUSTOMER_CHAT_ENABLED');
  const CHAT_WIDGET_VARIANT = getEnvValue('REACT_APP_CHAT_WIDGET');

  return KUSTOMER_ENABLED === 'yes' && CHAT_WIDGET_VARIANT === 'kustomer';
};

export const shouldOverrideKustomerAgentStatus = () => {
  const AGENT_STATUS_OVERRIDE = getEnvValue(
    'REACT_APP_KUSTOMER_AGENT_STATUS_OVERRIDE'
  );
  return AGENT_STATUS_OVERRIDE === 'yes';
};

export default isKustomerChatEnabled;
